import React from "react";
import ReactModal from "react-modal";
import Loader from "../../common/loader.jsx";
import { toast } from "react-toastify";
import axios from "../../requests/axios.js";

function QueueTranscodeDialog({ contentId, contentType, onClose, onSuccess, isOpen, transcodeType }) {
  const [isLoading, setIsLoading] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState({});

  function onSubmit() {
    setIsLoading(true);
    const endpointRoot = contentType + "s";

    axios
      .post(`/api/${endpointRoot}/${contentId}/transcode/${transcodeType}`)
      .then(() => {
        toast.success("Program transcoding queued");
        onClose();
        onSuccess();
      })
      .catch((error) => {
        console.error(error);
        if (error.status === 422) {
          formatApiErrors(error.data.errors || error.data.error);
        } else if (error.status === 500 || error.status === 404) {
          setErrorMessage({ api: "There was an error queueing this program for transcoding. Please contact support." });
        }
      })
      .finally(() => setIsLoading(false));
  }

  function formatApiErrors(errorObj) {
    let apiErrors = {};

    for (const key in errorObj) {
      if (errorObj.hasOwnProperty(key)) {
        apiErrors[key] = errorObj[key].join(". ");
      }
    }

    setErrorMessage(apiErrors);
  }

  return (
    <ReactModal isOpen={isOpen} ariaHideApp={false}>
      <div className="v-react-modal__inner modal-width">
        <div className="v-react-modal__heading">Transcode Content</div>
        <div className="v-react-modal__body modal-body">
          Are you sure you wish to queue this program for {transcodeType.toUpperCase()} transcoding?
          {errorMessage.program ? <p className="u-fc--warning">{errorMessage.program}</p> : null}
          {errorMessage.api ? <p className="u-fc--warning">{errorMessage.api}</p> : null}
        </div>
        <div className="v-react-modal__footer">
          {isLoading ? (
            <Loader width={45} height={45} />
          ) : (
            <React.Fragment>
              <button className="btn btn--inverse-primary" onClick={onClose}>
                Cancel
              </button>
              <button className="btn btn--primary" onClick={onSubmit}>
                Confirm
              </button>
            </React.Fragment>
          )}
        </div>
      </div>
    </ReactModal>
  );
}

export default QueueTranscodeDialog;
